module.exports = __webpack_public_path__ + "static/img/rodapeLogo.3db158f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/CUIABA/rodapeLogo.png
// module id = w/ji
// module chunks = 1